/**
 * @file page loader
 * @author Ice(chenzhouji@baidu.com)
 */

import React from 'react';
import {map} from 'lodash';
import * as tmp from 'react-router-dom';

// ignore waring `"export 'Navigate' (imported as 'rc') was not found in 'react-router-dom'`
const rc = tmp as any;

export interface RouteObjectV5 {
    path: string;
    redirectTo?: string;
    exact?: boolean;
    strict?: boolean;
    component?: any;
}

export type RouteObjectV6 = tmp.RouteProps & {
    redirectTo?: string;
}

export type RouteObject = RouteObjectV5 | RouteObjectV6;

const {Route} = rc;

const isV5 = 'Redirect' in rc;
const isV6 = 'Navigate' in rc;

const renderRoutesV5 = (routes: RouteObjectV5[]) =>
    map(routes, route => {
        const {path, component = null, exact, strict, redirectTo} = route;
        if (redirectTo) {
            return <rc.Redirect key={path} path={path} to={redirectTo} />;
        }
        const config = {
            path,
            exact,
            strict,
            component
        };
        return <Route key={path} {...config} />;
    });

const renderRoutesV6 = (routes: RouteObjectV6[]) =>
    map(routes, route => {
        const {redirectTo} = route;
        if (redirectTo) {
            return <rc.Navigate to={redirectTo} replace />;
        }
        return <rc.Route {...route} />;
    });

export default (routes: RouteObject[]) => {
    if (!isV5 && !isV6) {
        return null;
    }
    return isV6
        ? renderRoutesV6(routes as RouteObjectV6[])
        : renderRoutesV5(routes as RouteObjectV5[]);
};
